import { render, staticRenderFns } from "./DateFormatPreview.vue?vue&type=template&id=18dd8e8a&"
import script from "./DateFormatPreview.vue?vue&type=script&lang=ts&"
export * from "./DateFormatPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports